
export const defaultActiveActuals = [
    { label: "Actual", value: "actual", color: "bg-gray-900" },
    { label: "Forecast", value: "forecast", color: "bg-gray-500" },
    { label: "Variance", value: "variance", color: "bg-yellow-600" },
    { label: "Units (Forecast)", value: "units-forecast", color: "bg-green-600" },
    { label: "Units Sold (Actual)", value: "units-sold-actual", color: "bg-red-600" },
    { label: "Units Variance", value: "units-active", color: "bg-yellow-600" },
]

export const sortOptionsByForecastProducts = [
    { label: "⬆ Actuals (Ascending)", value: "actuals_asc" },
    { label: "⬇ Actuals (Descending)", value: "actuals_desc" },
    { label: "⬆ Forecast (Ascending)", value: "forecast_asc" },
    { label: "⬇ Forecast (Descending)", value: "forecast_desc" },
    { label: "⬆ Variance (Ascending)", value: "variance_asc" },
    { label: "⬇ Variance (Descending)", value: "variance_desc" },
    { label: "⬆ Units (Ascending)", value: "units_asc" },
    { label: "⬇ Units (Descending)", value: "units_desc" },
    { label: "⬆ Units Sold (Ascending)", value: "units_sold_asc" },
    { label: "⬇ Units Sold (Descending)", value: "units_sold_desc" },
    { label: "⬆ Variance (Units) (Ascending)", value: "units_variance_asc" },
    { label: "⬇ Variance (Units) (Descending)", value: "units_variance_desc" },
];

export const forecastsOptions = [
    { label: "Base Forecast", value: "BASE" },
    { label: "Growth Forecast", value: "GROWTH" },
    { label: "Aggressive Forecast", value: "AGGRESSIVE" },
];

export const ACTUAL = "actual";
export const FORECAST = "forecast";
export const VARIANCE = "variance";
export const UNITS_FORECAST = "units-forecast";
export const UNITS_SOLD_ACTUAL = "units-sold-actual";
export const UNITS_ACTIVE = "units-active";

export const defaultForecastProductsSortOrder = "actuals_desc";

export const defaultActiveValuesOfActuals = [ACTUAL, FORECAST, VARIANCE, UNITS_FORECAST, UNITS_SOLD_ACTUAL, UNITS_ACTIVE];

export const defaultChannelsBreakdown = {
    shopify: {},
    amazon: {},
    wholesale: {}
};

export const defaultMonthlyBreakdown = {
    "jan": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "feb": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "mar": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "apr": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "may": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "jun": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "jul": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "aug": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "sep": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "oct": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "nov": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
    "dec": { forecast: 0, actual: 0, variance: 0, cmForecast: 0, cmActual: 0, cmVariance: 0 },
}